<template>
  <div class="loader"></div>
</template>

<script>
export default {

}
</script>

<style>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 20%;
  background-color: none;
  z-index: 9999;
}

.loader::before {
  content: "";
  border-radius: 50%;
  width: 5em;
  height: 5em;
  border: 0.6em solid #3f3aa1;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>